import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavigationBar = ({ navigationLinks }) => {
  const location = useLocation();
  const lastEndpoint = location.pathname.split("/").filter(Boolean).pop();

  return (
    <div className="w-full h-fit flex justify-between items-center border rounded-full">
      {navigationLinks?.map((item, index) => {
        const capitalizedLink = item.link.split("/").filter(Boolean).pop();

        return (
          <Link
            to={item.link}
            key={index}
            className={`${
              lastEndpoint === capitalizedLink
                ? "bg-primaryColor text-whiteColor rounded-full px-[5%] py-[1.5%]"
                : "bg-whiteColor text-textSecondaryColor rounded-full px-[5%] py-[1.5%]"
            } font-normal text-[3.5vw] lg:text-[1vw] whitespace-nowrap`}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

export default NavigationBar;
